
<template>
  <layout licenseTypeName="网络版" @confirm="handleSave" :showFooter="false">
    <!-- -----------------------------------------------购买明细插槽------------------------------------------------------------ -->

    <template v-slot:center>
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <!-- <other-form ref="otherForm" :info="info" @confirm="confirm" /> -->
          <div v-loading="loading">
            <div class="my-font-xs">
              <div class="my-p-t-10">选择版本</div>
              <div class="my-p-t-10">
                <el-radio-group v-model="bookInfo.tenantVersion" @input="orderCalcAmount">
                  <el-radio :label="item.code" v-for="(item,index) in versionList" :key="index">{{ item.name }}</el-radio>
                </el-radio-group>
              </div>

              <div v-if="details && details.length>0">
                <div class="my-p-t-10">选购插件</div>
                <div v-for="(item,index) in details" :key="index" style="padding: 10px 0;" class="my-flex my-col-top">
                  <div
                    class="my-m-t-5"
                    :class="['custom-radio my-m-r-20', item.changeType =='BuyYears' ||item.changeType =='BuyForever' ? 'custom-radio-active':'']"
                    @click="handleRadio(index)"
                  >
                    <i class="el-icon-check" style="color: #fff;"></i>
                  </div>
                  <div class="my-flex-1">
                    <div class="my-flex">
                      <div class="my-flex-1">
                        <!-- 名称 -->
                        <div>{{item.licenseModuleText}}</div>
                        <!-- 状态 -->
                        <div class="color-info">
                          <div v-if="item.currentStatus == 'OngoingYears'">
                            {{`剩余 ${timeHelper.getDiffDays(new Date(timeHelper.dateFormat(new Date())),new Date(item.currentTimeEnd))}天`}}
                            <!-- 版本时间和模块时间不一致时显示 -->
                            <span
                              style="margin-left: 5px;"
                              v-if="new Date(item.currentTimeEnd).getTime() != new Date(bookInfo.tenantVersionTimeEnd).getTime()"
                            >({{item.currentTimeEnd}})</span>
                          </div>

                          <div v-if="item.currentStatus == 'Timeout'">{{`${item.currentStatusText}于 ${item.currentTimeEnd}`}}</div>

                          <div v-if="item.currentStatus == 'None'">未开通</div>
                        </div>
                      </div>
                      <!-- 加减框 -->
                      <div>
                        <span v-if="item.unit" class="color-info my-m-r-10">单位：{{item.unit}}</span>
                        <el-input-number size="mini" v-model="item.licenseValue" @change="orderCalcAmount" :min="1" :max="100"></el-input-number>
                      </div>
                    </div>
                    <!-- 有效期 价格-->
                    <div class="my-flex my-p-b-5" style="border-bottom: 1px solid #eee;" v-if="item.changeType =='BuyYears'">
                      <!-- 有效期 -->
                      <div class="color-info my-flex-1">
                        有效期至：
                        <span v-if="new Date(item.licenseTimeEnd).getFullYear() >8000">长期</span>
                        <span v-else>{{timeHelper.dateFormat(item.licenseTimeEnd) }}</span>
                      </div>
                      <!-- 价格 -->
                      <div class="color-error">￥{{item.amount.toFixed(2)}}</div>
                    </div>

                    <!-- 时长差价 -->
                    <div class="my-p-b-5 my-p-t-5" style="border-bottom: 1px solid #eee;" v-if="item.appendTimeAmount">
                      <div class="my-flex my-col-top">
                        <div class="color-warning my-flex-1">{{item.appendTimeDesc}}</div>
                        <div
                          class="color-error my-p-l-5"
                          v-if="item.appendTimeAmount > 0&&item.appendTimeRange"
                        >￥{{item.appendTimeAmount.toFixed(2)}}</div>
                      </div>
                      <div class="color-info" v-if="item.appendTimeAmount > 0&&item.appendTimeRange">{{item.appendTimeRange}}</div>
                    </div>
                    <!-- 模块差价 -->
                    <div class="my-p-b-5 my-p-t-5" style="border-bottom: 1px solid #eee;" v-if="item.appendValueAmount">
                      <div class="my-flex my-col-top">
                        <div class="color-warning my-flex-1">{{item.appendValueDesc}}</div>
                        <div
                          class="color-error my-p-l-5"
                          v-if="item.appendValueAmount > 0&&item.appendValueRange"
                        >￥{{item.appendValueAmount.toFixed(2)}}</div>
                      </div>
                      <div class="color-info" v-if="item.appendValueAmount > 0&&item.appendValueRange">{{item.appendValueRange}}</div>
                    </div>
                  </div>
                </div>
                <div class="my-p-t-20 my-p-b-20 my-text-center color-info" v-if="details.length == 0">暂未购买模块</div>
              </div>

              <div class="my-p-t-10">购买时长</div>
              <div class="my-p-t-10">
                <el-radio-group v-model="years" @input="changeYears">
                  <el-radio :label="item.value" v-for="(item,index) in timeList" :key="index">{{ item.name }}</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- -----------------------------------------------合计金额------------------------------------------------------------ -->
      <div>
        <div style="font-size: 14px;">
          <span>
            价格：￥
            <span style="color: #f30c0c; font-weight: bold; font-size: 18px;">{{amount.toFixed(2)}}</span>
          </span>
        </div>
        <div class="my-flex">
          <div class="my-flex">
            <el-button @click="handleSave" type="primary" style="margin-top: 10px;" :loading="saving">提交订单</el-button>
            <span v-if="bookInfo.tenantAccount" class="my-font-xs my-type-info my-m-l-10">当前账号：</span>
            <span v-if="bookInfo.tenantAccount" class="my-font-xs my-type-info">{{ bookInfo.tenantAccount }}（{{ bookInfo.company }}）</span>
          </div>
          <div class="my-flex-1 my-row-right my-flex">
            <contact-service :width="80" desc titleSize="12" />
          </div>
        </div>
      </div>
      <pay-dialog :no="no" :amount="amount" ref="payDialog" @confirm="confirmPay" />
    </template>

    <!-- -----------------------------------------------金额插槽------------------------------------------------------------ -->
    <!-- 
    <template v-slot:amount>
      <div class="col box-price">
        <div class="left">
          <span>价格：</span>
          <span class="span-price">￥{{amount.toFixed(2)}}</span>
        </div>
        <div class="right">
          <span style="text-decoration:line-through;color:#666;">原价：￥{{originalAmount}}</span>
        </div>
      </div>
    </template>-->
  </layout>
</template>
    
<script>
import { mapGetters } from 'vuex'
import API from '@/api/order'
import API_Soft from '@/api/soft'
import API_User from '@/api/user'
import API_Book from '@/api/book'
import layout from './components/_layout.vue'
import payDialog from './components/payDialog.vue'
// import otherForm from './components/otherForm.vue'

export default {
  components: {
    layout,
    payDialog
    // otherForm,
  },
  name: 'BuyNetworkOther',
  data() {
    return {
      loading: false,
      saving: false,
      //基本信息
      bookInfo: {
        id: '',
        name: '',
        company: '',
        tenantId: '',
        tenantVersion: ''
      },

      versionList: [],
      timeList: [
        {
          name: '1年',
          value: 1
        },
        {
          name: '2年',
          value: 2
        },
        {
          name: '3年',
          value: 3
        },
        {
          name: '长期',
          value: 0
        }
      ],

      years: 1, //购买时长
      changeType: 'BuyYears',
      details: [],
      no: '',
      amount: 0,
      originalAmount: 0
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  mounted() {},
  created() {
    console.log('buyOther this.$route.query', this.$route.query)

    // this.gSetting.product.timeList.forEach(item => {
    //   this.timeList.push(item)
    // })

    // 如果传过来bookId  证明已经登陆过
    if (this.$route.query.bookId) {
      //为指定账本购买
      API_Book.getInfo({ id: this.$route.query.bookId })
        .then(res => {
          this.bookInfo = res.data
          console.log('this.bookInfo', this.bookInfo)

          //获取版本列表
          this.getVersionList()
        })
        .catch(err => {
          console.log('err', err)
          this.goBuy()
        })
    } else {
      //没有登录 正常不会进入该页面
      //当前有登录状态
      if (this.isLogin) {
        //获取userInfo
        API_User.getInfo({ refresh: true })
          .then(res => {
            this.$store.dispatch('dataCache/setUserInfo', res.data)
            this.bookInfo = this.common.getBookInfoFromUserInfo(res.data)
            console.log('API_User.getInfo this.bookInfo', this.bookInfo)
            //获取版本列表
            this.getVersionList()
          })
          .catch(err => {
            console.log('err', err)
            this.goBuy()
          })
      } else {
        //没有登录 正常不会进入该页面
        this.goBuy()
      }
    }
    this.$eventBus.$on('LoginOutUpdate', this.goBuy)
  },
  beforeDestroy() {
    this.$eventBus.$off('LoginOutUpdate', this.goBuy)
  },
  methods: {
    goBuy() {
      window.location = `/#/buy`
    },
    changeYears() {
      this.details.forEach(item => {
        if (item.changeType != 'None') {
          if (this.years >= 1) {
            if (!item.priceYear) {
              item.changeType = 'None'
            } else {
              item.changeType = 'BuyYears'
            }
          } else {
            if (!item.priceForever) {
              item.changeType = 'None'
            } else {
              item.changeType = 'BuyForever'
            }
          }
        }
      })
      if (this.years > 0) {
        this.changeType = 'BuyYears'
      } else {
        this.changeType = 'BuyForever'
      }

      this.orderCalcAmount()
    },
    handleRadio(index) {
      let detail = this.details[index]
      if (detail.changeType == 'BuyYears') {
        detail.changeType = 'None'
      } else {
        detail.changeType = 'BuyYears'
      }
      this.$set(this.details, index, detail)
      this.orderCalcAmount()
    },
    //获取版本列表
    getVersionList() {
      this.loading = true
      API_Soft.getVersions({
        product: this.utils.getProductCode(),
        licenseType: 'Network'
      }).then(res => {
        this.versionList = res.data.list
        this.diffList = res.data.diffs
        this.introList = res.data.intros

        let vIndex = Math.max(
          this.versionList.findIndex(m => m.code == this.bookInfo.tenantVersion),
          0
        )
        this.bookInfo.tenantVersion = this.versionList[vIndex].code
        this.loading = false
        this.$nextTick(() => {
          this.getModuleList()
        })
      })
    },
    //获取模块列表
    getModuleList() {
      let details = []
      if (this.utils.getProductCode() != 'ES') {
        details.push({
          amount: 0,
          appendTimeAmount: 0,
          appendTimeDesc: '',
          changeType: 'BuyYears',
          licenseModule: 'User',
          licenseModuleText: '子用户',
          licenseTimeEnd: '',
          licenseValue: '1'
        })
      }

      this.details = details
      //计算价格
      this.orderCalcAmount()
    },
    setDetail_Version() {
      return {
        currentType: 'None',
        currentTypeText: '未开通',
        cate: 'Version', //'Module  模块'
        licenseModule: this.bookInfo.tenantVersion,
        changeType: this.changeType,
        licenseValue: '',
        years: this.years
      }
    },
    setDetail_Module(detail) {
      return {
        currentType: 'None',
        currentTypeText: '未开通',
        cate: 'Module',
        licenseModule: detail.licenseModule,
        changeType: detail.changeType,
        licenseValue: detail.licenseValue,
        years: this.years
      }
    },

    //计算价格
    orderCalcAmount() {
      let obj = {
        product: this.utils.getProductCode(),
        licenseType: 'Network',
        invite: '',
        couponId: '',
        tenantAccount: this.bookInfo.tenantAccount
      }
      let details = []
      details.push(this.setDetail_Version())
      this.details.forEach(item => {
        details.push(this.setDetail_Module(item))
      })
      obj.details = details
      API.postOrderCalcAmount(obj).then(res => {
        this.amount = res.data.amount
        this.$emit('confirm', res.data)

        let details = JSON.parse(JSON.stringify(res.data.details))
        details = details.filter(item => item.cate !== 'Version')
        details.forEach(item => {
          item.licenseValue = item.licenseValue ? Number(item.licenseValue) : item.licenseValue
        })
        this.details = details
      })
    },
    //提交订单
    handleSave() {
      let obj = {
        from: 'Web',
        product: this.utils.getProductCode(),
        years: this.years,
        licenseType: 'Network',
        couponId: '',
        tenantAccount: this.bookInfo.tenantAccount
      }
      let details = []
      details.push(this.setDetail_Version())
      this.details.forEach(item => {
        details.push(this.setDetail_Module(item))
      })
      obj.details = details
      API.postOrderCreate(obj)
        .then(res => {
          this.saving = false
          this.no = res.data
          this.$refs.payDialog.handleOpen()
        })
        .catch(err => {
          console.error(err)
          this.saving = false
        })
    },
    //应该没有调用
    confirm(data) {
      this.amount = data.amount
      this.originalAmount = data.originalAmount
    },
    //支付成功回调
    confirmPay() {
      window.location.href = this.softPrice.softWebUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-radio {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 1px solid #ccc;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-radio-active {
  background-color: #2979ff;
  border: none;
}
</style>